import { createContext } from "react";
import { AvailableUserThemes, BackgroundThemeRevision, GroupThemeRevision, HeaderThemeRevision, NavbarThemeRevision, PageRevision, PageRevisionResult, PageThemeRevision, ReferralThemeRevision } from "referral-types";
import { KeyedMutator } from "swr";
import { UpdateOptions } from "../../constants";

type PageContextType = {
  pageRevisions?: PageRevisionResult;
  pageRevision?: PageRevision;
  
  // Individual memoized theme revisions
  backgroundThemeRevision?: BackgroundThemeRevision;
  pageThemeRevision?: PageThemeRevision;
  groupThemeRevision?: GroupThemeRevision;
  referralThemeRevision?: ReferralThemeRevision;
  navbarThemeRevision?: NavbarThemeRevision;
  headerThemeRevision?: HeaderThemeRevision;
  
  // Note: updates and setUpdates moved to PageRevisionUpdatesContext for performance
  availableUserThemes?: AvailableUserThemes;
  updatePageRevision: (options: UpdateOptions) => Promise<void>;
  mutator: KeyedMutator<PageRevisionResult>;
  refresh: () => Promise<PageRevisionResult | undefined>;

  updateBackgroundTheme: (themeId: string) => void;
  updatePageTheme: (themeId: string) => void;
  updateGroupTheme: (themeId: string) => void;
  updateReferralTheme: (themeId: string) => void;
  updateNavbarTheme: (themeId: string) => void;
  updateHeaderTheme: (themeId: string) => void;

  setLogoOverride: (file?: File | null) => void;
  logoOverride?: File | null;
  backgroundImageOverride?: File | null;
  setBackgroundImageOverride: (file?: File | null) => void;
  backgroundImageMobileOverride?: File | null;
  setBackgroundImageMobileOverride: (file?: File | null) => void;
  groupMediaOverride?: File | null;
  handleSetGroupMediaOverride: (file?: File | null) => void;
  headerMediaOverride?: File | null;
  handleSetHeaderMediaOverride: (file?: File | null) => void;
  
  // Note: updates, setUpdates, and hasUnsavedChanges moved to PageRevisionUpdatesContext for performance
};

export const PageRevisionContext = createContext<PageContextType | undefined>(undefined);
